import { Button, DropdownMenu, DropdownMenuItem, Icon, Chip } from 'dreambel-ui';
import { downloadFramerie } from '../../utils/download';
import { scrollToSection } from '../../utils/scroll';
import { t } from 'i18next';

export function HeaderActions() {
  const appVersion = import.meta.env.VITE_APP_VERSION || '1.0.0';
  
  const menuTrigger = (
    <Button variant="text" className="p-2" aria-label="Menu">
      <Icon name="menu" />
    </Button>
  );

  return (
    <div className="flex items-center gap-4">
      {/* Actions principales */}
      {/* <Button variant="text">{t('header.actions.login')}</Button> */}
      <Button variant="filled" onClick={downloadFramerie}>
        {t('header.actions.download')}
      </Button>
      <Chip variant="outlined" className="hidden sm:flex font-mono text-xs">
        v{appVersion}
      </Chip>
      {/* Menu mobile visible uniquement sur les écrans < lg */}
      <div className="lg:hidden">
        <DropdownMenu trigger={menuTrigger}>
          <DropdownMenuItem>
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left"
            >
              {t('header.navigation.home')}
            </button>
          </DropdownMenuItem>
          <DropdownMenuItem>
            <button
              onClick={() => scrollToSection('features')}
              className="block w-full text-left"
            >
              {t('header.navigation.features')}
            </button>
          </DropdownMenuItem>
          <DropdownMenuItem>
            <button
              onClick={() => scrollToSection('pricing')}
              className="block w-full text-left"
            >
              {t('header.navigation.pricing')}
            </button>
          </DropdownMenuItem>
          <DropdownMenuItem>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left"
            >
              {t('header.navigation.faq')}
            </button>
          </DropdownMenuItem>
        </DropdownMenu>
      </div>
    </div>
  );
}
